import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular-ivy';
import { SentryConfigurationService } from './improver-sentry-configuration.service';
import { SENTRY_ERROR_LOGGER } from './sentry.model';

@NgModule({
  imports: [CommonModule],
})
export class InfrastructureSentryModule {
  static forRoot(): ModuleWithProviders<InfrastructureSentryModule> {
    return {
      ngModule: InfrastructureSentryModule,
      providers: [
        SentryConfigurationService,
        {
          provide: SENTRY_ERROR_LOGGER,
          useValue: Sentry.createErrorHandler(),
        },
        {
          provide: Sentry.TraceService,
          deps: [Router],
        },
        provideAppInitializer(() => {
          const service = inject(SentryConfigurationService);

          return service.initialize();
        }),
      ],
    };
  }
}
